import { optionMapping } from "../defaultValues/nominee";
import { getStorageItem } from "./utils";
import moment from "moment";
import { SLUG_AVAILABLE, SLUG_DIFFERENT } from "../constants";

export const isNomineeMinor = (age) => {
  return age < 18;
};

export const isNomineeAdult = (age) => {
  return age && age >= 18;
};

export const buildNomineeRelationshipList = (age = 0) => {
  return ["Wife", "Husband", "Mother", "Father", "Daughter", "Son"];
  // return isNomineeMinor(age)
  //   ? ["Daughter", "Son"]
  //   : ["Wife", "Husband", "Mother", "Father", "Daughter", "Son"];
};

export const buildUpdateOrderPayload = (status) => {
  return {
    oid: Number(getStorageItem("oid")),
    status,
  };
};

export const buildGenerateDocumentsPayload = (type = "SAVINGS") => {
  return {
    oid: Number(getStorageItem("oid")),
    type,
  };
};

export const buildSendDocumentsAndVerificationLinkPayload = (
  type = "SAVINGS"
) => {
  return {
    cid: Number(getStorageItem("cid")),
    oid: Number(getStorageItem("oid")),
    type,
    timestamps: Math.floor(Date.now() / 1000),
  };
};

export const buildSendInstaPolicyConfirmationPayload = (type = "SAVINGS") => {
  return {
    oid: Number(getStorageItem("oid")),
    type,
  };
};

export const buildCreateNastiePayload = (type = "SAVINGS") => {
  return {
    oid: Number(getStorageItem("oid")),
    type,
  };
};

export const buildUpdateNomineePayload = (
  {
    nominee_name,
    nominee_dob,
    nominee_relationship,
    nominee_gender,
    nominee_age,
    nominee_mobile_available,
    nominee_mobile_same_as_owner,
    nominee_mobile,
    nominee_email_available,
    nominee_email_same_as_owner,
    nominee_email,
    nominee_bank_details_available,
    nominee_bank_details_same_as_owner,
    nominee_bank_account_holder_name,
    nominee_bank_account_number,
    nominee_bank_account_type,
    nominee_bank_micr_code,
    nominee_bank_ifsc_code,
    appointee_name,
    appointee_dob,
    appointee_relationship,
    appointee_gender,
    appointee_mobile_available,
    appointee_mobile_same_as_owner,
    appointee_mobile,
    appointee_email_available,
    appointee_email_same_as_owner,
    appointee_email,
    appointee_bank_details_available,
    appointee_bank_details_same_as_owner,
    appointee_bank_account_holder_name,
    appointee_bank_account_number,
    appointee_bank_account_type,
    appointee_bank_micr_code,
    appointee_bank_ifsc_code,
  },
  selectedBankOption1 = null,
  selectedBankOption2 = null
) => {
  const nominee_bank_name = selectedBankOption1?.label ?? "";
  const nominee_bank_code = selectedBankOption1?.code ?? "";
  const appointee_bank_name = selectedBankOption2?.label ?? "";
  const appointee_bank_code = selectedBankOption2?.code ?? "";
  return {
    isMinor: isNomineeMinor(nominee_age),
    cid: Number(getStorageItem("cid")),
    name: nominee_name.trim().replace(/\s+/g, " "),
    dob: moment(nominee_dob).format("DD/MM/YYYY"),
    dobcache: nominee_dob,
    relationship: nominee_relationship,
    others: "",
    gender: nominee_gender,
    nominee_mobile_available: optionMapping[nominee_mobile_available],
    nominee_mobile_same: optionMapping[nominee_mobile_same_as_owner],
    nominee_mobile,
    nominee_email_available: optionMapping[nominee_email_available],
    nominee_email_same: optionMapping[nominee_email_same_as_owner],
    nominee_email,
    nominee_bank_details_available:
      optionMapping[nominee_bank_details_available],
    nominee_bank_details_same:
      optionMapping[nominee_bank_details_same_as_owner],
    nominee_bank_account_holder_name: nominee_bank_account_holder_name,
    nominee_bank_account_number: nominee_bank_account_number,
    nominee_bank_name,
    nominee_bank_code,
    nominee_bank_account_type: nominee_bank_account_type,
    nominee_bank_ifsc_code: nominee_bank_ifsc_code
      ? nominee_bank_ifsc_code.toUpperCase()
      : "",
    nominee_bank_micr_code: nominee_bank_micr_code,
    appointee_name: appointee_name
      ? appointee_name.trim().replace(/\s+/g, " ")
      : "",
    appointee_dob: moment(appointee_dob).format("DD/MM/YYYY"),
    appointee_relationship,
    appointee_others: "",
    appointee_gender,
    appointee_mobile_available: optionMapping[appointee_mobile_available],
    appointee_mobile_same: optionMapping[appointee_mobile_same_as_owner],
    appointee_mobile,
    appointee_email_available: optionMapping[appointee_email_available],
    appointee_email_same: optionMapping[appointee_email_same_as_owner],
    appointee_email,
    appointee_bank_details_available:
      optionMapping[appointee_bank_details_available],
    appointee_bank_details_same:
      optionMapping[appointee_bank_details_same_as_owner],
    appointee_bank_account_holder_name: appointee_bank_account_holder_name,
    appointee_bank_account_number: appointee_bank_account_number,
    appointee_bank_name,
    appointee_bank_code,
    appointee_bank_account_type: appointee_bank_account_type,
    appointee_bank_ifsc_code: appointee_bank_ifsc_code
      ? appointee_bank_ifsc_code.toUpperCase()
      : "",
    appointee_bank_micr_code: appointee_bank_micr_code,
  };
};

export const isAppointeePersonalDetailsMissing = (
  {
    appointee_name,
    appointee_dob,
    appointee_relationship,
    appointee_gender,
    appointee_mobile_available,
    appointee_mobile_same_as_owner,
    appointee_mobile,
    appointee_email_available,
    appointee_email_same_as_owner,
  },
  errorMessage
) => {
  return (
    !appointee_name ||
    !appointee_dob ||
    errorMessage.appointee_dob ||
    !appointee_relationship ||
    !appointee_gender ||
    (appointee_mobile_available === SLUG_AVAILABLE &&
      appointee_mobile_same_as_owner === SLUG_DIFFERENT &&
      (!appointee_mobile || errorMessage.appointee_mobile)) ||
    (appointee_email_available === SLUG_AVAILABLE &&
      appointee_email_same_as_owner === SLUG_DIFFERENT &&
      errorMessage.appointee_email)
  );
};

export const isAppointeeBankDetailsMissing = (
  {
    appointee_bank_details_available,
    appointee_bank_details_same_as_owner,
    appointee_bank_account_holder_name,
    appointee_bank_account_number,
    appointee_bank_account_type,
    appointee_bank_ifsc_code,
  },
  errorMessage,
  selectedBankOption
) => {
  return (
    appointee_bank_details_available === SLUG_AVAILABLE &&
    appointee_bank_details_same_as_owner === SLUG_DIFFERENT &&
    (!appointee_bank_account_holder_name ||
      errorMessage.appointee_bank_account_holder_name ||
      !appointee_bank_account_number ||
      errorMessage.appointee_bank_account_number ||
      !appointee_bank_account_type ||
      errorMessage.appointee_bank_account_type ||
      !appointee_bank_ifsc_code ||
      errorMessage.appointee_bank_ifsc_code ||
      !selectedBankOption?.code ||
      !selectedBankOption?.label)
  );
};

export const isAppointeeDetailsMissing = (
  form,
  errorMessage,
  selectedBankOptionNominee
) => {
  return (
    isAppointeePersonalDetailsMissing(form, errorMessage) ||
    isAppointeeBankDetailsMissing(form, errorMessage, selectedBankOptionNominee)
  );
};

export const isNomineePersonalDetailsMissing = (
  {
    nominee_name,
    nominee_dob,
    nominee_relationship,
    nominee_gender,
    nominee_mobile_available,
    nominee_mobile_same_as_owner,
    nominee_mobile,
    nominee_email_available,
    nominee_email_same_as_owner,
  },
  errorMessage
) => {
  return (
    !nominee_name ||
    !nominee_dob ||
    errorMessage.nominee_dob ||
    !nominee_relationship ||
    !nominee_gender ||
    (nominee_mobile_available === SLUG_AVAILABLE &&
      nominee_mobile_same_as_owner === SLUG_DIFFERENT &&
      (!nominee_mobile || errorMessage.nominee_mobile)) ||
    (nominee_email_available === SLUG_AVAILABLE &&
      nominee_email_same_as_owner === SLUG_DIFFERENT &&
      errorMessage.nominee_email)
  );
};

export const isNomineeBankDetailsMissing = (
  {
    nominee_bank_details_available,
    nominee_bank_details_same_as_owner,
    nominee_bank_account_holder_name,
    nominee_bank_account_number,
    nominee_bank_account_type,
    nominee_bank_ifsc_code,
  },
  errorMessage,
  selectedBankOption
) => {
  return (
    nominee_bank_details_available === SLUG_AVAILABLE &&
    nominee_bank_details_same_as_owner === SLUG_DIFFERENT &&
    (!nominee_bank_account_holder_name ||
      errorMessage.nominee_bank_account_holder_name ||
      !nominee_bank_account_number ||
      errorMessage.nominee_bank_account_number ||
      !nominee_bank_account_type ||
      errorMessage.nominee_bank_account_type ||
      !nominee_bank_ifsc_code ||
      errorMessage.nominee_bank_ifsc_code ||
      !selectedBankOption?.code ||
      !selectedBankOption?.label)
  );
};

export const isNomineeDetailsMissing = (
  form,
  errorMessage,
  selectedBankOptionNominee
) => {
  return (
    isNomineePersonalDetailsMissing(form, errorMessage) ||
    isNomineeBankDetailsMissing(form, errorMessage, selectedBankOptionNominee)
  );
};

export const isNomineeProceedButtonDisabled = (
  form,
  errorMessage,
  selectedBankOptionNominee = null,
  selectedBankOptionAppointee = null
) => {
  let isDisabled = false;
  if (isNomineeAdult(form.nominee_age)) {
    if (
      isNomineeDetailsMissing(form, errorMessage, selectedBankOptionNominee)
    ) {
      isDisabled = true;
    }
  } else if (isNomineeMinor(form.nominee_age)) {
    if (
      isAppointeeDetailsMissing(form, errorMessage, selectedBankOptionAppointee)
    ) {
      isDisabled = true;
    }
  }

  return isDisabled;
};
